module.exports = {
  subjects: (Api) ->
    return Api.MonitoringSubjects.get(outstanding_only: true).$promise
}
